import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Brain, Github, ExternalLink } from 'lucide-react';

export function Footer() {
  return (
    <footer className="mt-12 pt-8 border-t border-border">
      <Card className="bg-muted/30">
        <CardContent className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* About Section */}
            <div>
              <h3 className="font-semibold mb-3 flex items-center gap-2">
                <Brain className="h-4 w-4 text-primary" />
                About This Research
              </h3>
              <p className="text-sm text-muted-foreground mb-4">
                Open source annotation of AI/real music data for advancing artificial intelligence research. 
                All annotations will be released anonymously on Hugging Face and GitHub to help the AI research community.
              </p>
              <Button asChild variant="outline" size="sm" className="gap-2">
                <Link to="/research">
                  <ExternalLink className="h-3 w-3" />
                  Learn More
                </Link>
              </Button>
            </div>

            {/* Links Section */}
            <div>
              <h3 className="font-semibold mb-3">Resources</h3>
              <div className="space-y-2 text-sm">
                <div>
                  <a
                    href="https://laion.ai/impressum/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
                  >
                    <ExternalLink className="h-3 w-3" />
                    LAION Impressum
                  </a>
                </div>
                <div>
                  <a
                    href="https://github.com/LAION-AI"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
                  >
                    <Github className="h-3 w-3" />
                    LAION GitHub
                  </a>
                </div>
                <div>
                  <Link
                    to="/research"
                    className="text-muted-foreground hover:text-primary transition-colors"
                  >
                    Research Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
          
          <div className="mt-6 pt-4 border-t border-border text-xs text-muted-foreground text-center">
            <p>© 2025 LAION. Contributing to open AI research through collaborative data annotation.</p>
          </div>
        </CardContent>
      </Card>
    </footer>
  );
}
